import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import get from 'get-value';
import PropTypes from 'prop-types';
import set from 'set-value';
import {DISTRIBUTION_FORM} from '../../../constants/formConstants';
import {
    resetDistributionTicket, createDistributionTicket
} from '../../../actions/distribution/actionDistributionTicket';
import {initNewDistributionTicket, transformNewDistributionTicketForSave} from '../Utils';
import {clearAlerts} from '../../../actions/alertsActions';
import {createRights} from '../../../constants/distributionTicketRights';
import {createReqFields} from '../../../constants/distributionRequiredFields';
import UploadingDistributionAttachment from './UploadingDistributionAttachment';
import DistributionTicketMasterForm from './forms/DistributionTicketMasterForm';
import checkRoles from '../../common/roleChecker/RoleChecker';
import NoBirComponent from '../../common/NoBirComponent';
import ValidFormattedMessage from '../../common/ValidFormattedMessage';
import PageHeader from '../../common/PageHeader';
import Loader from '../../Loader';
import formTypeMessages from '../../../intl/modules/formTypeMessages';
import {moduleRoles} from '../../../utils/roles';

class NewDistributionTicketPage extends Component {
    constructor(props) {
        super(props);
        this.state = {ticketSubmittedAndShouldRedirect: false};
    }

    componentDidMount() {
        this.props.clearAlerts();
        this.props.resetDistributionTicket();
    }

    handleSubmit = (values) => {
        const dataForSend = transformNewDistributionTicketForSave(values.newValues);
        this.props.createDistributionTicket(dataForSend);
        this.setState({ticketSubmittedAndShouldRedirect: true});
    };

    render() {
        const {type, ticketData, attachmentsData, isLoadingSubjects, isSubstituted, loggedUser} = this.props;

        if (Array.isArray(attachmentsData.attachmentsForUpload) && (attachmentsData.attachmentsForUpload.length > 0)) {
            return <UploadingDistributionAttachment attachments={attachmentsData.attachmentsForUpload}
                                                    attachmentsUrl={ticketData.newAttachments}
                                                    correlationId={ticketData.correlationId}
                                                    isAttachmentUploading={attachmentsData.isTicketAttachmentUploading}
                                                    formType={type}/>
        }

        if (this.state.ticketSubmittedAndShouldRedirect && !ticketData.isTicketCreating
            && !ticketData.isTicketLoading && get(ticketData, 'ticket.uuid', {default: false})) {
            return <Redirect to={{
                pathname: `/distribution/view/${ticketData.ticket.uuid}`,
                redirectedAfterUpdate: true
            }}/>;
        }

        if (!type
            || this.state.ticketSubmittedAndShouldRedirect
            || isLoadingSubjects
        ) {
            return <Loader/>;
        }

        const initializationValue = initNewDistributionTicket(this.props.userDetail);
        if (!initializationValue) {
            return <NoBirComponent formType={type}/>;
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<ValidFormattedMessage message={type} intlMessages={formTypeMessages}/>}/>

                <div>
                    {type === DISTRIBUTION_FORM &&
                    <DistributionTicketMasterForm form={type}
                                                  initialValues={set(initializationValue, 'ticketSection.type', DISTRIBUTION_FORM)}
                                                  userRights={createRights}
                                                  reqFields={createReqFields[type]}
                                                  enableReinitialize={true}
                                                  isEditor={moduleRoles.isEditorDistribution(loggedUser)}
                                                  isSubstituted={isSubstituted}
                                                  handleSubmit={this.handleSubmit}/>
                    }
                </div>
            </div>
        )
    }
}

NewDistributionTicketPage.propTypes = {
    clearAlerts: PropTypes.func.isRequired,
    createDistributionTicket: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    userDetail: PropTypes.object.isRequired,
    loggedUser: PropTypes.object.isRequired,
    ticketData: PropTypes.object.isRequired,
    attachmentsData: PropTypes.object.isRequired,
    clientIds: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    userDetail: state.profile.userDetail,
    loggedUser: state.profile.userDetail.roles,
    ticketData: state.distributionTicket,
    attachmentsData: state.distributionAttachment,
    isLoadingSubjects: state.adminSubjectSettings.isLoading,
    isSubstituted: state.distributionTicket.substitutionUser,
});

export default checkRoles(withRouter(connect(mapStateToProps, {
    clearAlerts,
    createDistributionTicket,
    resetDistributionTicket,
})(NewDistributionTicketPage)), ['DB_DEALER', "DB_EDITOR"]);
